export default __webpack_public_path__ + "static/media/MovieTogether.bdb88056.png";